export default __webpack_public_path__ + "static/media/SWT0830.34I-19838_-14742_0.d07c4cb2.jpg";